var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSecurityHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L0 8V24L16 32L32 24V8L16 0ZM16 29L2 22V10L16 17V29Z",
    fill: "#42526D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSecurityHub);
export default __webpack_public_path__ + "static/media/AWS_security_hub.fd09f2f2ed0de87b4e922ffa60fa8b06.svg";
export { ForwardRef as ReactComponent };